export default "__VITE_ASSET__49ebfa51__"